import React from 'react';
import { isPathbuddyHost } from '../../config/eduHost';
import PathbuddySiteFooter from './PathbuddySiteFooter';
import CookieSettingsButton from '../consent/CookieSettingsButton';

export default function EduSiteFooter() {
  // pathbuddy.com gets the full editorial-style footer; edu.ivori.ai stays minimal.
  if (isPathbuddyHost()) {
    return <PathbuddySiteFooter />;
  }

  const handleHomeClick = (e) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleAppsClick = (e) => {
    e.preventDefault();
    const el = document.getElementById('edu-landing-apps');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="edu-landing-footer">
      <div className="edu-landing-footer-inner">
        <div className="edu-landing-footer-brand">IVORI Edu</div>
        <nav className="edu-landing-footer-nav">
          <a href="https://ivorilab.com" target="_blank" rel="noopener noreferrer">
            IVORI Lab
          </a>
          <a href="https://ivoriai.com" target="_blank" rel="noopener noreferrer">
            ivoriai.com
          </a>
          <a href="#edu-landing-apps" onClick={handleAppsClick}>
            Apps
          </a>
          <a href="#edu-landing-top" onClick={handleHomeClick}>
            Home
          </a>
          <CookieSettingsButton />
        </nav>
        <div className="edu-landing-footer-meta">© 2026 IVORI Lab</div>
      </div>
    </footer>
  );
}
